module.exports = __webpack_public_path__ + "static/media/donut-chart-average.c004e02b.svg";